import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';

import Snoozes from 'api/resources/snoozes';
import { processErrorByAlert } from 'utils/getErrors';
import getFileName from 'utils/getFileName';
import { Deserializer } from 'jsonapi-serializer';

import Input from 'styled/Input';
import Label from 'styled/Label';
import ButtonLoader from 'components/Loader/ButtonLoader';
import PrimaryButton from 'styled/Buttons/PrimaryButton';
import SectionHeader from 'styled/Page/SectionHeader';
import RightColumnBody from 'styled/Page/RightColumnBody';
import SmallFormTextarea from 'styled/Editor/SmallFormTextarea';
import ChooseFileField from 'admin-editor/components/ChooseFileField';

class CreateSnooze extends React.Component {
  constructor(props) {
    super(props);

    this.handleNameChange = this.handleChange.bind(this, 'name');
    this.handleReactionChange = this.handleChange.bind(this, 'reaction');
    this.handleCommentChange = this.handleChange.bind(this, 'comment');
 }

  state = {
    name: '',
    reaction: '',
    comment: '',
    gif: undefined,
    icon: undefined,
    loading: false,
  }

  handleChange = (field, e) => {
    this.setState({ [field]: e.target.value });
  }

  handleGifLoad = (file) => {
    this.setState({
      gif: {
        filename: getFileName({
          url: file.attributes.path,
          type: '/snoozes',
        }),
        file_type: file.attributes.content_type,
        file_size: file.attributes.size,
        width: file.attributes.width,
        height: file.attributes.height,
        medialib_item_id: file.id,
      },
    });
  }

  handleIconLoad = (file) => {
    this.setState({
      icon: {
        filename: getFileName({
          url: file.attributes.path,
          type: '/snoozes',
        }),
        file_type: file.attributes.content_type,
        file_size: file.attributes.size,
        width: file.attributes.width,
        height: file.attributes.height,
        medialib_item_id: file.id,
      },
    });
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    if (!this.state.gif) {
      processErrorByAlert('Поле gif-анимация не может быть пустым');
      return;
    }

    if (!this.state.icon) {
      processErrorByAlert('Поле иконки снуза не может быть пустым');
      return;
    }

    this.setState({ loading: true });

    try {
      const response = await Snoozes.create({
        body: {
          data: {
            type: 'snooze',
            attributes: {
              name: this.state.name,
              reaction: this.state.reaction,
              comment: this.state.comment,
            },
            relationships: {
              gif: {
                data: {
                  type: 'image',
                  attributes: this.state.gif,
                },
              },
              icon: {
                data: {
                  type: 'image',
                  attributes: this.state.icon,
                },
              },
            },
          },
        },
       });

      const snooze = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);
      this.props.onCreate(snooze);

      Alert.success('Снуз успешно создан');

      this.setState({
        loading: false,
        name: '',
        reaction: '',
        comment: '',
        gif: undefined,
        icon: undefined,
      });
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <React.Fragment>
        <SectionHeader>Создать снуз</SectionHeader>

        <RightColumnBody
          as="form"
          style={{ paddingBottom: '40px' }}
          onSubmit={this.handleSubmit}
        >
          <Label htmlFor="name">Название снуза</Label>

          <Input
            id="name"
            type="text"
            maxLength={80}
            value={this.state.name}
            placeholder="Введите название"
            style={{ marginBottom: '24px' }}
            onChange={this.handleNameChange}
          />

          <Label htmlFor="reaction">Реакция</Label>

          <Input
            id="reaction"
            type="text"
            value={this.state.reaction}
            style={{ marginBottom: '24px' }}
            onChange={this.handleReactionChange}
            placeholder="Введите реакцию"
          />

          <ChooseFileField
            label="Иконка снуза"
            accept="image/png,image/jpeg"
            mediaType="snoozes"
            name={this.state.icon && this.state.icon.filename}
            onLoad={this.handleIconLoad}
          />

          <ChooseFileField
            label="Gif-анимация"
            accept="image/gif"
            mediaType="snoozes"
            name={this.state.gif && this.state.gif.filename}
            onLoad={this.handleGifLoad}
          />

          <Label htmlFor="comment">Комментарий</Label>

          <SmallFormTextarea
            id="comment"
            value={this.state.comment}
            onChange={this.handleCommentChange}
            maxLength={250}
          />

          <PrimaryButton type="submit" style={{ width: '109px' }}>
            {this.state.loading ? <ButtonLoader /> : 'добавить'}
          </PrimaryButton>
        </RightColumnBody>
      </React.Fragment>
    );
  }
}

CreateSnooze.defaultProps = {
  onCreate: () => {},
};

CreateSnooze.propTypes = {
  onCreate: PropTypes.func,
};

export default CreateSnooze;
